export default {
  DesktopSystemMessages__NO_ALERTS: "You have no alerts at this time.",
};
